import { useEffect } from 'react';

// Hauteur réelle de la barre de navigation fixe (h-20 = 80 px).
// On ne la mesure pas dans le DOM car le menu mobile ouvert fausse la valeur.
const HEADER_OFFSET = 80;

// Gestionnaire global des liens d'ancre internes (href="#...").
// Garantit un défilement doux et fiable vers la section ciblée, sans
// rechargement de page ni retour en haut, et compense le menu fixe.
export default function SmoothAnchors() {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      // On ignore les clics modifiés (nouvel onglet, etc.).
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const target = (event.target as HTMLElement | null)?.closest('a');
      if (!target) return;

      const href = target.getAttribute('href') ?? '';
      if (!href.startsWith('#') || href === '#') return;

      const id = href.slice(1);
      const el = document.getElementById(id);
      if (!el) return;

      event.preventDefault();

      const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
      window.history.replaceState(null, '', href);
    };

    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);

  return null;
}